<template>
  <div class="app2">
	<!-- <heads :title="title" type="2"></heads> -->
	<div class="content">
		<van-empty v-if="list.length == 0" description="暂无数据" />
		<div v-else class="content-nav" v-for="item in list">
			<div class="content-nav-card" @click="goPage(item)">
				<div>
					<img :src="item.fmtp[0]" alt="">
				</div>
				<div class="content_s">
					<div class="bts">
						<p>{{item.bt}}</p>
						<div>
							<img :src="item.imgType" alt="">
							<p @click.stop="clearFb(item)" v-if="clearType==0">取消</p>
						</div>
					</div>
				</div>
				<div class="other-time" v-if="clearType==0 || clearType==3">
					<p>发布时间：{{item.fbsj || '--'}}</p>
					<p>到期日期：{{item.gqsj || '--'}}</p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker,Dialog } from 'vant'
export default {
	props: {
		list: {
		type: Array,
            default() {
                return []
            },
		},
		pth: {
            type: String,
            default: "/hmhq/detailView",
		},
		clearType: {
			type:Number,
			default:1
		}
	},
	data(){
		return{
		}
	},
	mounted() {

	},
	methods:{
		goPage(e){
			this.$store.state.wallView = e
			let params = {id:1}
			this.$router.push({
				path:this.pth,
				query:params
			})
		},
		phone(number){
			console.log("联系电话",number);
		},
		call(itm){
			window.location.href="tel:"+itm.lxdh
		},
		clearFb(item){
			Dialog.confirm({
			title: '',
			message: '取消发布',
			})
			.then(() => {
				let params = {
					id:item.id
				}
				getAction('/zhshj/hmfwggq/qxfb',params).then(res=>{
					this.$router.go(0)
				})
			})
			.catch(() => {
			});
		}
	}
}
</script>

<style scoped lang="less">
.app2{
	width: 100%;
	height: 100%;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}
.content{
	padding: 0px 10px 50px;
	font-size: 16px;
	box-sizing: border-box;
	&-nav{
		width: 100%;
		border-radius: 10px;
		margin-bottom: 16px;
		background: white;
		overflow: hidden;
		&-card{
			background: white;
			padding: 10px 12px;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			box-sizing: border-box;
			>div:first-child{
				width: 24%;
				height: 80px;
				img{
					width: 100%;
					height: 100%;
					max-width: 94%;
				}
			}
			.content_s{
				width: 74%;
				position: relative;
				.bts{
					width: 100%;
					height: 100%;
					display: flex;
					flex-wrap: wrap;
					flex-direction: column;
					justify-content: space-between;
					>p{
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2; //行数
						-webkit-box-orient: vertical;
					}
					div{
						display: flex;
						justify-content: space-between;
						p{
							color: #969696;
							font-size: 12px;
							padding: 2px 8px;
							background: #F5F6F8;
							border-radius: 6px;
							border: 1px solid #b5b5b580;
						}
					}
					img{
						width: 50px;
					}
				}
				.clearfb{
					position: absolute;
					right: 0px;
					top: 50%;
					background: #F5F6F8;
					border-radius: 6px;
					border: 1px solid #b5b5b580;
					transform: translateY(-50%);
					p{
						color: #969696;
						font-size: 14px;
						padding: 3px 8px;
					}
				}
			}
			.other-time{
				width: 100%;
				border-top: 1px solid #F5F6F8;
				padding: 8px 0px 0px;
				margin: 10px 0px 0px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				p{
					font-size: 10px;
					color: #B5B5B5;
				}
			}
		}
	}
}
</style>